import { parseQuery } from 'vue-router'
import type { LocationQueryRaw } from 'vue-router'
import { omit } from 'es-toolkit'

export const TERMS_KEYS = ['terms', 'general-terms', 'privacy-policy', 'excluded-games', 'bingo-games', 'jackpot-games']

// The terms dialog shows promotion terms over the others while any of these is in the query.
export const PROMOTION_PARAMS = ['promotionId', 'promotionReferenceId', 'bonusReferenceId', 'referenceId']

/**
 * Turns a terms link, either a hash (`#terms?promotionId=42`) or a hashless query on the current page (`?general-terms=true`),
 * into a query merged into the current one, so the page underneath keeps its state. Undefined for any other link.
 */
export function getTermsLinkQuery(href: string, currentUrl: string, currentQuery: LocationQueryRaw = parseQuery(new URL(currentUrl).search)): LocationQueryRaw | undefined {
    let url: URL

    try {
        url = new URL(href, currentUrl)
    }
    catch {
        return
    }

    const hashText = url.hash.slice(1)
    const hashKey = hashText.split('?')[0]!
    let linkQuery: LocationQueryRaw

    if (TERMS_KEYS.includes(hashKey)) {
        linkQuery = { [hashKey]: 'true', ...parseQuery(hashText.slice(hashKey.length)) }
    }
    else {
        const current = new URL(currentUrl)

        // A relative `#kontakt` resolves to the current query, which holds the terms while the dialog is open.
        if (url.hash || url.origin !== current.origin || url.pathname !== current.pathname) return

        linkQuery = parseQuery(url.search)

        if (![...TERMS_KEYS, ...PROMOTION_PARAMS].some(key => key in linkQuery)) return
    }

    return { ...omit(currentQuery, [...TERMS_KEYS, ...PROMOTION_PARAMS]), ...linkQuery }
}
